import * as React from "react";
import TileContent from "../TileContent";
import {getPadding, getTileClasses} from "../TileMethods";
import TileImage from "../TileImage";

export const Stacked = ({ data, height, settings, isMobile }) => {

    const paddingContent = getPadding(data);
    const tileClasses = getTileClasses(data, isMobile, paddingContent);

    // Determine if text should be displayed above image
    const isTextAbove = data.settings.layout === "stacked_text_above";
    
    // Check if image should be shown on mobile
    const shouldShowImage = !isMobile || (isMobile && data.settings.show_image_on_mobile !== false);

    const tileContent = (
        <div className={`tileitem z-[2] ${(isMobile && data.settings.use_screen_width_mobile) && `w-screen`} color-${data.color_schema} ${data.settings.padding_area == "outside" && paddingContent}
        
                 ml-[${data.settings.margin_left_mobile}px]
                 lg:ml-[${data.settings.margin_left}px]
                 mr-[${data.settings.margin_right_mobile}px]
                 lg:mr-[${data.settings.margin_right}px]
                 `}>
            {isTextAbove && (
                <div className="tile__container">
                    <div className={`tile__info ${tileClasses}`}>
                        <TileContent data={data} isMobile={isMobile} globals={settings.globals} />
                    </div>
                </div>
            )}
            {shouldShowImage && (
                <TileImage data={data} height={height} isMobile={isMobile} />
            )}
            {!isTextAbove && (
                <div className="tile__container">
                    <div className={`tile__info ${data.settings.image ? "flex w-full z-[5]" : ""} ${tileClasses}`}>
                        <TileContent data={data} isMobile={isMobile} globals={settings.globals} />
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <>
            {data.settings.make_tile_clickable ? (
                <div
                    onClick={() => (window.location.href = data.settings.button_url)}
                    className={`custom-class ${data.settings.main_aspect_ratio && data.settings.aspect_ratio_type }`}
                    style={{ cursor: "pointer"}}
                >
                    {tileContent}
                </div>
            ) : (
                tileContent
            )}
        </>
    );
};

export default Stacked;
